import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { SharedServicesModule } from './shared-services/shared-services.module';
import { SecurityModule } from './security/security.module';
import { CoreModule } from './core/core.module';
import { VendorModule } from './core/vendor.module';
import { HomeModule } from './home/home.module';
import { ClienteModule } from './cliente/cliente.module';
import { NotificacionModule } from './notificacion/notificacion.module';
import { FormsModule } from '@angular/forms';
import { ProductoModule } from './productos/producto.module';
import { ConfiguracionModule } from './configuracion/configuracion.module';
import { AcuerdoModule } from './acuerdo/acuerdo.module';
import { PedidoComponent } from './pedido/pedido.component';
import { PedidoListComponent } from './pedido/pedido-list/pedido-list.component';
import { PedidoDetailsComponent } from './pedido/pedido-details/pedido-details.component';
import { PedidoModule } from './pedido/pedido.module';
import { CotizacionModule } from './shared-components/cotizacion/cotizacion.module';
import { BannerModule } from './banner/banner.module';
import { TiposEnvioModule } from './tiposEnvio/tiposEnvio.module';
import { JucModule } from './juc/juc.module';



@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    SharedServicesModule,
    SecurityModule,
    ClienteModule,
    CoreModule,
    VendorModule,
    HomeModule,
    ClienteModule,
    AcuerdoModule,
    NotificacionModule,
    ProductoModule,
    ConfiguracionModule,
    PedidoModule,
    CotizacionModule,
    BannerModule,
    TiposEnvioModule,
    JucModule
  ],
  providers: [
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts